export default "__VITE_ASSET__6130a53c__"